import { useEffect, useRef, useState } from 'react';
import FlightInfoRow from './FlightInfoRow';

export const DeferredFlightInfoRow = ({
  flight,
  kind,
  isSelected,
  onSelect,
  isBookingPage = false,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const rowRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    if (rowRef.current) {
      observer.observe(rowRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={rowRef}>
      {isVisible ? (
        <FlightInfoRow
          flight={flight}
          kind={kind}
          isSelected={isSelected}
          onSelect={onSelect}
          isBookingPage={isBookingPage}
        />
      ) : (
        <div style={{ height: '100px' }} /> // Placeholder mientras carga
      )}
    </div>
  );
};
